

































































import MenuMixin from '@/mixins/menu-mixin';
import DatasourceServices from '@/services/datasource';
import { mixins } from 'vue-class-component';
import { Vue, Component, Watch } from 'vue-property-decorator';
import DatasourceObject from './datasource-object.vue';
import EsConfDetail from './es-conf-detail.vue';
import DsConfDetail from './ds-conf-detail.vue';
import FileConfDetail from './file-conf-detail.vue';
import KafkaConfDetail from './kafka-conf-detail.vue';
import HiveConfDetail from './hive-conf-detail.vue';
import DorisConfDetail from './doris-conf-detail.vue';

@Component({
  components: { DatasourceObject, EsConfDetail, DsConfDetail, FileConfDetail, KafkaConfDetail, HiveConfDetail, DorisConfDetail }
})
export default class DatasourceDetail extends mixins(MenuMixin) {
  dataSrv = new DatasourceServices();
  id: any = 0;
  info: any = {};
  dsType: string = '';
  spinning: boolean = false;

  async created() {
    this.id = this.$route.query.id;
  }

  @Watch('$route')
  onRouteChange() {
    this.id = this.$route.query.id;
    this.onIdChange();
  }

  @Watch('id')
  async onIdChange() {
    if (!this.id || this.$route.path != '/data/datasource/detail') return false;
    this.spinning = true;
    let res = await this.dataSrv.getInfo(this.id);
    this.spinning = false;
    if (!res) return false;
    this.info = res;
    this.dsType = res.dsType.toLowerCase();
  }

  get dsConfig() {
    return this.info.dsConfig || {};
  }
}
